import { StepFieldsMap } from 'sos-common/js/commonTypes/validation.types';

export const map = {
  0: {
    fieldNames: ['AccepteratVillkor'],
    stepId: 0,
  },
  1: {
    fieldNames: [
      'Person.Fornamn',
      'Person.Efternamn',
      'Befattning',
      'Telefon',
      'Epost',
      'Organisation.Namn',
      'Organisation.Organisationsnummer',
      'Organisation.Epost',
      'Organisation.Webbplats',
      'bilagor',
      'fullmakt',
    ],
    stepId: 1,
  },
  2: {
    fieldNames: ['CheckboxIntygan'],
    stepId: 2,
  },
} as StepFieldsMap;
